"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Name = exports.AddCustomerOrderEvent = void 0;
const Name = exports.Name = 'add-customer-order';
const AddCustomerOrderEvent = exports.AddCustomerOrderEvent = Name;
//# sourceMappingURL=index.js.map